import { createContext, useCallback, useContext, useState } from "react"
import { setRecordingGuard } from "../lib/recording-guard"

interface IRecordingStateContext {
  isRecordingActive: boolean
  setRecordingActive: (active: boolean) => void
}

const RecordingStateContext = createContext<IRecordingStateContext>({
  isRecordingActive: false,
  setRecordingActive: () => undefined,
})

export function RecordingStateProvider({ children }: { children: React.ReactNode }): React.ReactElement {
  const [isRecordingActive, setActive] = useState(false)
  const setRecordingActive = useCallback((active: boolean): void => {
    setActive(active)
    // Mirror to the module-level guard so out-of-React reload paths (vite:preloadError)
    // can defer while recording.
    setRecordingGuard(active)
  }, [])
  return (
    <RecordingStateContext.Provider value={{ isRecordingActive, setRecordingActive }}>
      {children}
    </RecordingStateContext.Provider>
  )
}

export function useRecordingState(): IRecordingStateContext {
  return useContext(RecordingStateContext)
}
